var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xhu-login-page"},[_c('ComHeaderLeft',{staticClass:"xhu-login-header"}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xhu-login-wrap"},[_c('img',{staticClass:"login-bg",attrs:{"src":require("../../static/images/login/bg.jpg")}}),_c('div',{staticClass:"login-content",attrs:{"id":"axxLogin"}})])
}]

export { render, staticRenderFns }